import type { MapTile, MapProjection } from "@oreme/ui";
import { MAP_VECTOR_TILE, MAP_PROJECTION } from "@oreme/ui/lib/constants";

const tiles: MapTile[] = [
  {
    id: "osm-openmaptiles",
    title: "Classic",
    url: MAP_VECTOR_TILE.OSMOpenMapTiles,
  },
  {
    id: "jawg-terrain",
    title: "Terrain",
    url: MAP_VECTOR_TILE.JawgTerrain,
  },
  {
    id: "ign-standard",
    title: "Plan IGN",
    url: MAP_VECTOR_TILE.IGNStandard,
  },
  {
    id: "positron",
    title: "Positron",
    url: MAP_VECTOR_TILE.Positron,
  },
  {
    id: "fiord-color",
    title: "FiordColor",
    url: MAP_VECTOR_TILE.FiordColor,
  },
  {
    id: "dark-matter",
    title: "DarkMatter",
    url: MAP_VECTOR_TILE.DarkMatter,
  },
  {
    id: "toner",
    title: "Toner",
    url: MAP_VECTOR_TILE.Toner,
  },
];

const mapTiles: Map<string, MapTile> = new Map(
  tiles.map((item) => [item.id, item]),
);

const projections: MapProjection[] = [
  {
    id: MAP_PROJECTION.GLOBE,
    title: "3D",
  },
  {
    id: MAP_PROJECTION.MERCATOR,
    title: "2D",
  },
];

const mapProjections: Map<string, MapProjection> = new Map(
  projections.map((item) => [item.id, item]),
);

export { mapTiles, mapProjections };
